import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-down",
  "use": "icon-down-usage",
  "viewBox": "0 0 28 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 28 18\" id=\"icon-down\"><defs><style>#icon-down .cls-1{fill:#99989a;}</style></defs><polygon class=\"cls-1\" points=\"13.94 18 27.76 0 0.11 0 13.94 18\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol